exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.reservation-event {\n  position: relative;\n  padding: 0.5rem;\n  border: 1px solid #DBDFE2;\n  border-radius: 4px;\n}\n.reservation-event img {\n    border-radius: 6px;\n    margin-right: 1rem;\n}\n.reservation-event .logo {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n}\n.reservation-event .price {\n    position: absolute;\n    bottom: 1rem;\n    right: 1rem;\n}\n.reservation-event.selected {\n    border: 2px solid #6ac951;\n    padding: calc(0.5rem - 2px);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2fb43a0a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/Events.vue
// module id = 1682
// module chunks = 0